import React, { useEffect } from "react";
import styles from "./slideshow.module.css";
import { useSelector, useDispatch } from "react-redux";
import { getPortal } from "../../services/selectors";

import { END_LOADING, START_LOADING_BLACK } from "../../services/actions/loading_actions";
import { INCREMENT_SLIDE, DECREMENT_SLIDE } from "../../services/actions/portal_actions";


const Slideshow = () => {

  const { images, index } = useSelector(getPortal);

  const dispatch = useDispatch();

  const handleDecrement = () => {
    dispatch({ type: START_LOADING_BLACK });
    dispatch({ type: DECREMENT_SLIDE });
  }
  const handleIncrement = () => {
    dispatch({ type: START_LOADING_BLACK });
    dispatch({ type: INCREMENT_SLIDE });
  }

  const defaultImageHandler = (e) => {
    // e.target.src = news_image_default;
    // поставить дефолтное изображение
  }

  const handleLoad = () => {
    dispatch({ type: END_LOADING });
  }

  useEffect(() => {
    dispatch({ type: START_LOADING_BLACK });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {
        Array.isArray(images) && images.length > 0 ?
          <div className={styles.container}>
            {images.length > 1 &&
              <button
                className={styles.buttonLeft}
                onClick={handleDecrement}
              />
            }
            <img className={styles.img}
              src={images[index]?.image}
              alt={`Изображение № ${index + 1}`}
              onError={defaultImageHandler}
              onLoad={handleLoad}
            />
            {images.length > 1 &&
              <button
                className={styles.buttonRight}
                onClick={handleIncrement}
              />
            }
          </div> : null
      }
    </>
  )
};

export default Slideshow;
